export default __webpack_public_path__ + "static/media/renew.83a0fcf8.webp";